import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import apiClient from "../common/http.service";

export const useFAQs = () => {
  const queryClient = useQueryClient();

  const faqQuery = useQuery({
    queryKey: ["faqs"],
    queryFn: async () => {
      const response = await apiClient.get("/faq");
      return response.data.data; 
    },

    staleTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });

  const createFAQ = useMutation({
    mutationFn: async (faqData) => {
      const response = await apiClient.post("/faq", faqData);
      return response.data;
    },

    onSuccess: () => {
      toast.success("FAQ created successfully");
      queryClient.invalidateQueries({ queryKey: ["faqs"] });
    },

    onError: (err) => {
      toast.error(err.response?.data?.message || "Create failed");
    },
  });

  const updateFAQ = useMutation({
    mutationFn: async ({ id, updatedData }) => {

      const response = await apiClient.put(
        `/faq/${id}`,
        updatedData
      );
      return response.data;
    },

    onSuccess: () => {
      toast.success("FAQ updated successfully");
      queryClient.invalidateQueries({ queryKey: ["faqs"] });
    },

    onError: (err) => {
      toast.error(err.response?.data?.message || "Update failed");
    },
  });

  const deleteFAQ = useMutation({
    mutationFn: async (id) => {

      const response = await apiClient.delete(`/faq/${id}`);


      return response.data;
    },

    onSuccess: () => {
      toast.success("FAQ deleted successfully");
      queryClient.invalidateQueries({ queryKey: ["faqs"] });
    },

    onError: (err) => {
      toast.error(err.response?.data?.message || "Delete failed");
    },
  });

  return {
    faqs: faqQuery.data || [],

    isLoading: faqQuery.isLoading,
    isError: faqQuery.isError,
    error: faqQuery.error,

    createFAQ: createFAQ.mutateAsync,
    isCreating: createFAQ.isPending,

    updateFAQ: updateFAQ.mutateAsync,
    isUpdating: updateFAQ.isPending,

    deleteFAQ: deleteFAQ.mutateAsync,
    isDeleting: deleteFAQ.isPending,
  };
};
